<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4" v-if="organization">
						<h4 class="mm-0 mb-4">Imports for {{ organization.name }}</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
		</div><!--row-->
		<div class="row">
			<div class="col-12 col-xl-7">
				<div class="table-responsive">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th class="green-content orderable">Name<span class="sorting"><span class="asc"></span><span class="desc"></span></span></th>
								<th class="green-content">Uploaded at</th>
								<th class="green-content">Status</th>
								<th class="width-150 text-center green-content">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in imports" >
								<td ><a class="bold" @click="selectImport(item)">{{ item.filename }}</a></td>
								<td>{{ item.uploaded_at }}</td>
								<td>{{ item.status }}</td>
								<td class="text-center">
									<router-link :to="{ name: 'admin.organizations.imports.detail', params : { id: id, import_id : item.id } }" tag="a" class="button">
										<img width="5" class="mr-1 ml-1" src="../../../../assets/images/icons/solid/info_white.svg" />
									</router-link>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="row justify-content-between ">
					<div class="col-12 col-lg-6">
						<span>Showing {{ imports_table.from }} to {{ imports_table.to }} of {{ imports_table.total }}</span>
					</div><!--col-->
					<div class="col-12 col-lg-6">
						<b-pagination align="right" :total-rows="imports_table.total" v-model="imports_table.current_page" 
								@change="setPage" :per-page="parseInt(imports_table.per_page)">
				    	</b-pagination>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
		</div><!--row-->

		<div class="row" v-if="import_selected">
			<div class="col-12">
				<p>Import: {{ import_selected.filename }}</p>

				<!--
				<table  class="table table-bordered">
	    			<thead>
	    				<th class="green-content orderable">New HHAs</th>
	    				<th class="green-content orderable">Already in the system</th>
	    				<th class="green-content orderable">Errors</th>
	    			</thead>
	    			<tbody>
	    				<tr>
	    					<td>{{ import_selected.unique_providers }}</td>
	    					<td>{{ import_selected.repeated_providers }}</td>
	    					<td>{{ import_selected.errors }}</td>
	    				</tr>
	    			</tbody>
	    		</table>
	    		-->
	    		<table  class="table table-bordered">
	    			<thead>
	    				<th class="green-content orderable">Row</th>
	    				<th class="green-content orderable">Status</th>
	    				<th class="green-content orderable">Errors</th>
	    			</thead>
	    			<tbody>
	    				<tr v-for="row in logs">
	    					<td>{{ row.index }}</td>
	    					<td>{{ row.status }}</td>
	    					<td>
	    						<ul>
	    							<li v-for="error in row.message">
	    								{{ error }}
	    							</li>

	    							<button v-if="row.status == 'ERROR'" @click="modalEditRow(row)">
	    								Edit
	    							</button>
	    						</ul>
	    					</td>
	    				</tr>
	    			</tbody>
	    		</table>
	    		<div class="row justify-content-between ">
					<div class="col-12 col-lg-6">
						<span>Showing {{ logs_table.from }} to {{ logs_table.to }} of {{ logs_table.total }}</span>
					</div><!--col-->
					<div class="col-12 col-lg-6">
						<b-pagination align="right" :total-rows="logs_table.total" v-model="logs_table.current_page" 
								@change="setPageLogs" :per-page="parseInt(logs_table.per_page)">
				    	</b-pagination>
					</div><!--col-->
				</div><!--row-->
	    		<!-- modal edit row -->
	    		<b-modal v-model="show_edit_row" title="Edit row" @ok="editRow()" cancel-title="Cancel" 
	    			ok-title="Edit"  size="lg">
	    			<form @submit.prevent="onSubmit">
				    	<div v-if="row_to_edit != null">

				    		<p>Row: {{ row_to_edit.index }}</p>
				    		<p>Errors</p>
				    		<ul>
					    		<li v-for="error in row_to_edit.message">
									{{ error }}
								</li>
							</ul>

						
							<div class="lightgray-content p-3 rounded mb-2">
								<div class="row">
									<div class="col-12 col-lg-4">
										<div class="form-group input-content">
											<label>Email</label>
											<input placeholder="Email" type="text" v-model="provider_data.email" class="form-control" v-validate="'email'" name="email">
											<span class="input-error-msg">{{ errors.first('email') }}</span>
										</div>
										<div class="form-group input-content">
											<label>First name</label>
											<input placeholder="First name" type="text" v-model="provider_data.first_name" class="form-control" v-validate="'required'" name="first_name">
											<span class="input-error-msg">{{ errors.first('first_name') }}</span>
										</div>
										<div class="form-group input-content">
											<label>Last name</label>
											<input placeholder="Last name" type="text" v-model="provider_data.last_name" class="form-control" v-validate="'required'" name="last_name">
											<span class="input-error-msg">{{ errors.first('last_name') }}</span>
										</div>
										<!-- <div class="form-group input-content">
											<label>Gender</label>
											<v-select class="mb-2"  :searchable="false"  :options="[{ 'value' : 0, 'label' : 'Male' }, { 'value' : 1, 'label' : 'Female' }]" v-model="provider_data.gender">
											</v-select>
										</div> -->
									</div><!--col-->
									<div class="col-12 col-lg-4">
										<!-- <div class="form-group input-content">
											<label>Birthday</label>
											<datetime hidden-name="dob" placeholder="Birthday" v-model="provider_data.dob"></datetime>
											<span class="input-error-msg">{{ errors.first('dob') }}</span>
										</div> -->
										
										<div class="form-group input-content">
											<label>Telephone number</label>
											<input placeholder="Telephone number" type="text" v-model="provider_data.phone" class="form-control" name="phone"  v-validate="'required'">
											<span class="input-error-msg">{{ errors.first('phone') }}</span>
										</div>
										<div class="form-group input-content">
											<label>Preferred language</label>
											<v-select class="mb-2"   :searchable="false"  :options="['English','Spanish']" v-model="provider_data.preferred_language">
											</v-select>
										</div>
										<div class="form-group input-content">
											<label>SSN</label>
											<input placeholder="SSN" type="text" v-model="provider_data.ssn" 
													class="form-control" v-validate="'required|numeric|length:9'" name="ssn">
											<span class="input-error-msg">{{ errors.first('ssn') }}</span>
										</div>
									</div><!--col-->
									<div class="col-12 col-lg-4">
								
										<div class="form-group input-content">
											<label>LHCSA manager</label>
											<input placeholder="Email" type="text"  class="form-control" 
												v-validate="'required|email'" name="lhcsa_manager" 
													v-model="provider_data.lhcsa_manager">
											<span class="input-error-msg">{{ errors.first('lhcsa_manager') }}</span>
										</div>
										<div class="form-group input-content">
											<label>Coordinator</label>
											<input placeholder="Email" type="text"  class="form-control" 
												v-validate="'required|email'" name="coordinator"
												v-model="provider_data.coordinator">
											<span class="input-error-msg">{{ errors.first('coordinator') }}</span>
										</div>
										<div class="form-group input-content">
											<label>Manager approving the hha score</label>
											<input placeholder="Last name" type="text"  class="form-control" 
												v-validate="'required|email'" 
											name="manager_approving_the_hha_score" v-model="provider_data.manager_approving_the_hha_score">
											<span class="input-error-msg">{{ errors.first('manager_approving_the_hha_score') }}</span>
										</div>
										<div class="form-group input-content">
											<label>Supporting RN</label>
											<input placeholder="Last name" type="text" class="form-control" 
												v-validate="'required|email'" name="supporting_rn"
												v-model="provider_data.supporting_rn">
											<span class="input-error-msg">{{ errors.first('supporting_rn') }}</span>
										</div>
									</div>
									<div class="col-12 col-lg-4">
										<div class="form-group input-content">
											<label>Employment date</label>
											<datetime hidden-name="dob" placeholder="Employment date" v-model="provider_data.onboard_date"></datetime>
											<span class="input-error-msg">{{ errors.first('onboard_date') }}</span>
										</div>
										<div class="form-group input-content">
											<label>Program starting date</label>
											<datetime hidden-name="dob" placeholder="Program starting date" v-model="provider_data.program_starting_date"></datetime>
											<span class="input-error-msg">{{ errors.first('program_starting_date') }}</span>
										</div>
										<div class="form-group input-content">
											<label>Duration method</label>
											<v-select class="mb-2"  :options="['1', '2', '3']" v-model="provider_data.duration_method">
											</v-select>
										</div>
									</div><!--col-->
								</div><!--row-->
							</div>
						
						</div>

						<div slot="modal-footer" class="w-100 row">
							<div class="col-6">
								<button class="button gray-content large-button w-100">Cancel</button>
							</div><!--col-->
							<div class="col-6">
								<button class="button large-button w-100" type="submit">Edit</button>
							</div><!--col-->
						</div>
					</form>
				</b-modal>
			</div>
		</div>
	</div><!--container-->
</template>

<script>
	export default {
		data : function(){
			return {
				imports_table : {
					current_page : 1,
					total : 0,
					per_page  : 10,
					from : 0,
					to : 0
				},
				imports : [],
				id : this.$route.params.id,
				organization : {
					email : '',
					name : '',
					year_founded : '',
					became_costumer : ''
				},
				import_selected : null,
				logs : [],
				row_to_edit : null,
				show_edit_row : false,
				provider_data : {
					ssn : '',
					first_name : '',
					last_name : '',
					// dob: '',
					// gender: '',
					preferred_language: '',
					phone: '',
					duration_method : '',
					employee_number : '',
					hha_registry_number : '',
					lhcsa_manager : '',
					manager_approving_the_hha_score : '',
					onboard_date : '',
					program_starting_date : '',
					supporting_rn : ''
				},
				logs_table : {
					current_page : 1,
					total : 0,
					per_page  : 10,
					from : 0,
					to : 0
				}
			}
		},
		created : function(){
			this.getOrganization();
		},

		methods : {

			getOrganization : function() {
				var params = {
					id : this.id
				}

				this.$store.dispatch('getOrganization', params).then((res) => {
					this.organization = res.data.data;

					this.getImports();
				}).catch((error) => {
					console.log(error);
				});
			},
			getImports : function(){
				var params = {
					id : this.id
				}

				this.$store.dispatch('getOrganizationImports', params).then((res) => {
					console.log(res);
					this.imports = res.data.data;
					this.imports_table = res.data.meta;
				}).catch((error) => {
					console.log(error);
				});

			},
			setPage : function(page){
				this.imports_table.current_page = page;

				this.getOrganization();
			},
			setPageLogs : function(page){
				this.logs_table.current_page = page;

				this.selectImport(this.import_selected);
			},
			selectImport : function(_import){
				this.import_selected = _import;

				var params = {
					id : this.id,
					import_id : _import.id,
					filters : {
						page : this.logs_table.current_page
					}
				}

				this.$store.dispatch('getOrganizationImportLogs', params).then((res) => {
					console.log(res);
					this.logs = res.data.data; 
					this.logs_table = res.data.meta;
				}).catch((error) => {
					console.log(error);
				});
			},
			modalEditRow : function(row){
				this.row_to_edit = row;
				this.show_edit_row = true;
				this.provider_data = this.row_to_edit.row;
				// this.provider_data.dob = this.row_to_edit.row.birthday;
				this.provider_data.phone = this.row_to_edit.row.telephone_number;
			},
			editRow : function(){

				var params = {
					id : this.id,
					import_id : this.import_selected.id,
					row_id : this.row_to_edit.id,
					data : this.row_to_edit
				}

				this.$store.dispatch('editOrganizationImportLog', params).then((res) => {
					console.log(res);
				}).catch((error) => {
					console.log(error);
				});
			},

			onSubmit : function(){
				console.log("process row", this.row_to_edit);

				this.$validator.validateAll().then((result) => {

					if(result){
						this.editRow();
					}
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/imports/AdminOrganizationImportsListComponent.vue